import { RouteLocationRaw } from "vue-router";
import { useCurrentUser } from "../api/current-user";
import { useFeaturesStore } from "../stores/features";
import { usePermissionStore } from "../stores/permission";

export const useLocationResolver = createSharedComposable(() => {
	const { currentUser } = useCurrentUser();

	const { isRouteActive } = useFeaturesStore();
	const { hasUserAccessToRoute } = usePermissionStore();

	const router = useRouter();

	function resolve(options: RouteLocationRaw): RouteLocationRaw | null {
		const route = router.resolve(options as any);
		if (route.meta.disabled) return null;

		if (route.meta.ignoreAuth) return options as any;

		if (!currentUser.value) return null;

		if (!hasUserAccessToRoute(route) || !isRouteActive(route)) {
			return null;
		}

		return options as any;
	}

	return {
		resolve,
	};
});
